import { faCartShopping } from '@fortawesome/pro-solid-svg-icons'

import { Heading } from '../Heading/Heading'
import { PrimaryButton } from '../PrimaryButton/PrimaryButton'
import { ProgressBar } from '../ProgressBar/ProgressBar'
import { CardHeader } from './CardHeader'
import { HEADER_SUBTITLE, HEADER_TEXT } from './CardHeader.constants'

export const CardHeaderPresentation = () => (
  <div className="d-flex flex-column">
    <Heading className="pt-4" size={4}>
      Headers:
    </Heading>

    {/* *** Basic Card Header *** */}

    <div className="mt-4">
      <CardHeader subtitle={HEADER_SUBTITLE}>
        <Heading size={4}>Headline 4 large</Heading>
      </CardHeader>
    </div>

    {/* *** Card Header with icons *** */}

    <div className="mt-4">
      <CardHeader icon={faCartShopping} iconRight subtitle={HEADER_SUBTITLE}>
        <Heading size={4}>Headline 4 large</Heading>
      </CardHeader>
    </div>

    {/* *** Card Header with progress bar *** */}

    <div className="mt-4">
      <CardHeader icon={faCartShopping} iconRight subtitle={HEADER_SUBTITLE}>
        <Heading size={4}>Headline 4 large</Heading>
      </CardHeader>

      <ProgressBar value={60} />
    </div>

    {/* *** Card Header with Button *** */}

    <div className="mt-4">
      <CardHeader
        rightContent={<PrimaryButton>New Rental</PrimaryButton>}
        subtitle={HEADER_TEXT}
      />

      <ProgressBar value={60} />
    </div>

    {/* *** Compact Card Header *** */}

    <div className="mt-4 card-header-compact">
      <CardHeader icon={faCartShopping} iconRight subtitle={HEADER_SUBTITLE}>
        <Heading size={4}>Headline 4 large</Heading>
      </CardHeader>

      <ProgressBar value={60} />
    </div>
  </div>
)
